(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealSection(section) {
    if (!section || section.dataset.bloomMotionReady === 'true') return;

    section.dataset.bloomMotionReady = 'true';
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-bloom-reveal]'));
    if (!items.length || reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-revealed'); });
      return;
    }

    section.classList.add('bloom-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8%', threshold: 0.12 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function initButtons(scope) {
    var selector = '.slide__buttons.main-buttons .slide__btn.btn, .ersa-best__button, .ersa-collections__button, .bhiw__button, .premium-newsletter__button, .ersa-best__quick-button, .ersa-best__quick-link';
    scope.querySelectorAll(selector).forEach(function (button) {
      var section = button.closest('[data-bloom-button-effect]');
      if (!section) return;
      button.classList.add('bloom-button');
      var secondary = button.closest('.main-buttons__item') && button.closest('.main-buttons__item').previousElementSibling;
      if (secondary) {
        button.classList.add('bloom-secondary');
        button.classList.toggle('bloom-shine', section.dataset.bloomSecondaryShine === 'true');
        return;
      }
      button.classList.toggle('bloom-calypso', section.dataset.bloomButtonEffect === 'calypso');
      Array.from(button.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.trim()) {
          var span = document.createElement('span');span.className = 'bloom-button-label';
          node.replaceWith(span);span.appendChild(node);
        } else if (node.nodeType === 1 && node.tagName === 'SPAN' && node.textContent.trim() && !node.querySelector('svg')) {
          node.classList.add('bloom-button-label');
        }
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    initButtons(root);
    if (root.matches && root.matches('[data-bloom-motion-section]')) revealSection(root);
    root.querySelectorAll('[data-bloom-motion-section]').forEach(revealSection);
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  var pendingQuickAddButton = null;
  var pendingQuickAddTimer = null;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bloom-quick-add] [data-add-to-cart]');
    if (!button) return;

    pendingQuickAddButton = button;
    window.clearTimeout(pendingQuickAddTimer);
    pendingQuickAddTimer = window.setTimeout(function () { pendingQuickAddButton = null; }, 8000);
  }, true);

  document.addEventListener('theme:cart:added', function () {
    if (!pendingQuickAddButton) return;

    var button = pendingQuickAddButton;
    var label = button.querySelector('[data-bloom-quick-add-label]');
    if (!label) return;

    var originalLabel = label.textContent;
    label.textContent = 'Added';
    button.classList.add('is-added');
    button.setAttribute('aria-label', 'Added to cart');
    pendingQuickAddButton = null;
    window.clearTimeout(pendingQuickAddTimer);

    window.setTimeout(function () {
      label.textContent = originalLabel;
      button.classList.remove('is-added');
      button.removeAttribute('aria-label');
    }, 1600);
  });

  function triggerTickerUpdate() {
    document.dispatchEvent(new CustomEvent('theme:resize:width'));
    window.dispatchEvent(new Event('resize'));
  }
  window.addEventListener('load', triggerTickerUpdate);
  window.addEventListener('orientationchange', triggerTickerUpdate);
  window.setTimeout(triggerTickerUpdate, 200);
  window.setTimeout(triggerTickerUpdate, 1000);
}());
